import React from 'react'

type DiscountHeaderProps = {
    percent: number
}

export const DiscountHeader = ({ percent = 0 }: DiscountHeaderProps) => {
    if (!percent) return null

    return (
        <div className="z-20 absolute top-0 left-0 justify-center items-center flex bg-yf-purple rounded-br-xl h-9 w-20">
            <p className="text-xs font-medium text-white">{percent}% off</p>
        </div>
    )
}
